import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import compose from 'recompose/compose'
import { connect as connectStaticText } from 'components/StaticText/connect'
import { connect as connectRedux } from 'react-redux'
import PlanCardGrid from 'components/PlanCardGrid'
import { H4 } from 'components/Heading'

const ModalCartChangePlan = ({
  history,
  staticText,
}) => {
  return (
    <div className="modal-cart-change-plan">
      <H4>{staticText.getIn(['data', 'changePlan'])}</H4>
      <PlanCardGrid history={history} isCheckoutChangePlan />
    </div>
  )
}

ModalCartChangePlan.propTypes = {
  history: PropTypes.object.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'modalCartChangePlan' }),
  connectRedux(
    (state) => ({
      user: state.user,
    }),
  ),
)(ModalCartChangePlan)
